import { useLocation } from "react-router-dom";
import { Link as HeroLink } from "@heroui/react";
import logo from "../assets/img/MASH-Primary-logo-White-cool.png";
import { FaXTwitter, FaTelegram } from "react-icons/fa6";

export const Footer = () => {
  const isMarketPage = useLocation().pathname.includes("/market/");

  if (isMarketPage) {
    return null;
  }

  return (
    <footer
      className="w-full flex justify-center items-center px-6 lg:px-60 py-12 text-white"
      style={{
        background: "#101017",
        boxShadow: "0 -4px 20px rgba(0,0,0,0.5)",
      }}
    >
      <div className="flex flex-col gap-6">
        <div className="flex flex-col items-center space-y-4">
          <img src={logo} alt="Logo" className="h-6 lg:h-8 w-auto" />
        </div>

        <div className="flex flex-wrap justify-center gap-x-4 gap-y-1">
          <HeroLink
            href="https://x.com/mashdotfun"
            target="_blank"
            rel="noreferrer"
          >
            <FaXTwitter className="w-5 h-5 dark:text-white/80 text-black hover:text-black transition-colors" />
          </HeroLink>
          <HeroLink
            href="https://t.me/mashdotfun"
            target="_blank"
            rel="noreferrer"
          >
            <FaTelegram className="w-5 h-5 dark:text-white/80 text-[#24A1DE] hover:text-[#24A1DE]/80 transition-colors" />
          </HeroLink>
        </div>
      </div>
    </footer>
  );
};
